export const ADMIN_ROLE_ID = 1;
export const DTS_ASSISTANT_ROLE_ID = 341;
export const DTS_PRODUCER_ROLE_ID = 343;
export const DTS_SUPPORT_ROLE_ID = 342;
export const EDITORIAL_TAG_ID = 4294;
export const MAX_MOODBOARDS_PER_USER = 30;
export const MAX_BOOKMARKS_PER_MOODBOARD = 75;
export const MAINTENANCE_ERROR_MESSAGE = 'The site is currently under maintenance.';
export const DEFAULT_MAINTENANCE_DESCRIPTION =
  'Experiencing a temporary glitch!\nFull service will be available ASAP';
export const MAINTENANCE_CHECKING_EXCEPTION_ENDPOINT = [
  'users.getAuthenticatedUser',
  'settings.getCurrentMaintenance',
];
export const DTS_PRICING_URL = 'https://www.deathtothestockphoto.com/pricing';
export const DTS_WEBSITE = 'https://www.deathtothestockphoto.com';

export const ACCEPTED_FILE_TYPES = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg'] as const;
export type AcceptedFileType = (typeof ACCEPTED_FILE_TYPES)[number];
export const EVENTS = {
  addedLink: 'Added Link',
  loadedSharedMoodboard: 'Loaded Shared Moodboard',
  loadedMoodboard: 'Loaded Moodboard',
  loadedPublicMoodboard: 'Loaded Public Moodboard',
  copiedMoodboard: 'Copied Moodboard',
  postLinkProviders: 'Post Providers',
  requestedLink: 'Requested Link',
  downloadedEcho: 'Downloaded echo',
  downloadedClip: 'Downloaded clip',
  downloadedVideo: 'Downloaded video',
  downloadedPhoto: 'Downloaded photo(s)',
};

export const ECHO_TRIGGER_STRING = 'echo66';
export const DEFAUL_MAIN_PAGE_WRAPPER_CLASS = 'mx-auto min-h-screen dts-fullpadded';
